import import_latest_version_module from '@/component/admin-layout/import_latest_version_module';

export default {
  path: '',
  component: () => import_latest_version_module(),
  children: [
    {
      path: '/admin/difengyun-order-affirm',
      name: 'admin-difengyun-order-affirm',
      component: () => import(/* webpackChunkName: "page-admin-difengyun-order-management-difengyun-order-affirm" */ `./index.vue`),
      meta: {
          data_for_admin_layout: {
                    data_for_history_tag: {
                              entity: {
                                        name: "订单确认管理"
                              }
                    },
                    data_for_breadcrumb: {
                              entity_list: [
                                        {
                                                  name: "笛风云订单管理"
                                        },
                                        {
                                                  name: "订单确认管理"
                                        }
                              ]
                    }
          }
},
    },
  ],
};
